module.exports = __webpack_public_path__ + "img/signup-carousel-sixth@3x.251f43e5.png";